
import { logger } from "@/lib/logger";

/**
 * Create the analysis prompt for AI
 * @returns The formatted analysis prompt
 */
export function createAnalysisPrompt(): string {
  logger.debug("Creating website analysis prompt");
  
  return `
You are a helpful assistant specializing in analyzing websites for businesses.

Extract the following information about the business from this website content:
1. Business name
2. Industry/sector
3. Primary services or products
4. Brief description (2-3 sentences)
5. Target audience or customer profile
6. Company size (small, medium, large, enterprise) if discoverable
7. Brand tone (professional, casual, technical, friendly, etc.)
8. Content formality level (formal, semi-formal, conversational)
9. Key topic keywords (up to 10)
10. Major brand colors (if mentioned)
11. Social media profiles (links to company profiles if found)
12. Key marketing messages or value propositions

For colors, extract specific color names or hex codes if present.
Format your response as valid JSON with these fields: businessName, industry, primaryServices, description, targetAudience, companySize, tone, formality, keywords (array), colors (array), socialMedia (object with platform names as keys and profile URLs as values), keyMessages (array).
`;
}
